import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'
/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
    getDisabledReferenceRequest: ['response'],
    getDisabledReferenceSuccess: ['response', 'loading'],
    getDisabledReferenceFailure: ['error'],
})

export const getDisabledReferenceTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
    response: null,
    error: null,
    loading: null,
})

/* ------------- Reducers ------------- */
const getDisabledReferenceSuccess = (state, { response }) =>
    state.merge({
        error: false,
        response,
        loading: false,
    })
const getDisabledReferenceFailure = (state, { error }) =>
    state.merge({
        loading: false,
        error,
    })
const getDisabledReferenceRequest = state =>
    state.merge({ loading: true, error: null })

export const reducer = createReducer(INITIAL_STATE, {
    [Types.GET_DISABLED_REFERENCE_REQUEST]: getDisabledReferenceRequest,
    [Types.GET_DISABLED_REFERENCE_SUCCESS]: getDisabledReferenceSuccess,
    [Types.GET_DISABLED_REFERENCE_FAILURE]: getDisabledReferenceFailure,
})
